export default __webpack_public_path__ + "static/media/SheetMetalImg4.29a8c587.jpg";